// extracted by mini-css-extract-plugin
export var blog__header = "blog-module--blog__header--M+1uj";
export var blog__articles = "blog-module--blog__articles--vZlGh";
export var blog = "blog-module--blog--zdHOT";
export var blog__link = "blog-module--blog__link--0P3Kp";